var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheveronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 192 106",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.2874105,-47.618282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "m 102.77254,154.02984 a 23.32341,23.32341 0 0 1 -13.033315,-4.01991 l -0.136426,0.0119 -1.525488,-1.25574 a 23.32341,23.32341 0 0 1 -0.822172,-0.67696 L 14.960844,88.57078 14.944824,88.2385 A 23.32341,23.32341 0 0 1 7.2874105,71.00441 23.32341,23.32341 0 0 1 30.611051,47.68129 a 23.32341,23.32341 0 0 1 16.61449,7.0373 l 0.05891,-0.078 55.653449,45.93104 56.95363,-46.8328 0.16227,0.11834 a 23.32341,23.32341 0 0 1 15.81557,-6.23889 23.32341,23.32341 0 0 1 23.32364,23.32364 23.32341,23.32341 0 0 1 -6.52725,16.17265 l -0.007,0.14263 -0.79788,0.65319 a 23.32341,23.32341 0 0 1 -2.50269,2.05 l -72.62658,59.47803 -0.0574,-0.005 a 23.32341,23.32341 0 0 1 -13.90199,4.59662 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheveronDown);
export default __webpack_public_path__ + "static/media/CheveronDown.85015843fa2f6d9b4c38f1f97154de56.svg";
export { ForwardRef as ReactComponent };